import React from 'react';

interface ModalProps {
  title: string;
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

export function Modal({
  title,
  show,
  onClose,
  children,
  size = 'md',
}: ModalProps): JSX.Element {
  return (
    <div className="news-modal" style={{ display: show ? 'block' : 'none' }}>
      <div
        className="modal fade"
        tabIndex={-1}
        id="modalDefault"
        style={{ display: 'block', opacity: 1 }}
      >
        <div className={`modal-dialog modal-${size}`} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <div role="button" className="close" onClick={onClose}>
                <em className="icon ni ni-cross" />
              </div>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: '90vh', overflow: 'scroll' }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
